const constants = require('@/util/constants')
require('./config')

// 拉取自己个人资料
export function getProfile(successcb, failedcb) {
    axios.get('/api/user/profile', {
        params: {
            'client': constants.HTTP_CLIENT
        }
    }).then(response => {
        successcb(response.data)
    }).catch(error => {
        failedcb(error)
    })
}

// 根据UID拉取其他用户uid
export function getProfileByUid(uid, successcb, failedcb) {
    axios.get('/api/user/profile/uid', {
        params: {
            'uid': uid,
            'client': constants.HTTP_CLIENT
        }
    }).then(response => {
        successcb(response.data)
    }).catch(error => {
        failedcb(error)
    })
}

// 拉取自己个人资料
// export function getProfileCache(successcb, failedcb) {
//     axios.get('/api/user/profile/cache', {
//         params: {
//             'client': constants.HTTP_CLIENT
//         }
//     }).then(response => {
//         successcb(response.data)
//     }).catch(error => {
//         failedcb(error)
//     })
// }

/**
 * 修改 个人资料
 * @param {*} username 用户名
 * @param {*} password 密码
 */
export function updateProfile (username, password, nickname, avatar, mobile, email,
    description, welcomeTip, successcb, failedcb) {
    axios.post('/api/user/update/profile', {
        username,
        password,
        nickname,
        avatar,
        mobile,
        email,
        description,
        welcomeTip
    }).then(response => {
        successcb(response.data)
    }).catch(error => {
        failedcb(error)
    })
}

/**
 * 客服给访客做备注：修改访客昵称
 * 访客uid/nickname
 * 
 * @param {*} username 用户名
 * @param {*} password 密码
 */
export function updateNote(uid, nickname, successcb, failedcb) {
    axios.post('/api/user/update/note', {
        uid,
        nickname
    }).then(response => {
        successcb(response.data)
    }).catch(error => {
        failedcb(error)
    })
}

/**
 * 设置 自动回复内容, 迁移到autoreply.js
 */
// export function updateAutoReply (autoReply, autoReplyContent, successcb, failedcb) {
//     axios.post('/api/v2/user/update/autoReply', {
//         autoReply,
//         autoReplyContent
//     }).then(response => {
//         successcb(response.data)
//     }).catch(error => {
//         failedcb(error)
//     })
// }

// export function updateAutoReply2(autoReply, content, imageUrl, successcb, failedcb) {
//     axios.post('/api/v1/autoreply/update', {
//         autoReply,
//         content,
//         imageUrl
//     }).then(response => {
//         successcb(response.data)
//     }).catch(error => {
//         failedcb(error)
//     })
// }

/**
 * 客服后台修改个人密码
 */
export function changePassword2 (password, successcb, failedcb) {
    axios.post('/api/user/change/password', {
        password
    }).then(response => {
        successcb(response.data)
    }).catch(error => {
        failedcb(error)
    })
}

/**
 * 初始化
 */
export function init (successcb, failedcb) {
    axios.get('/api/user/init', {
        params: {
        'client': constants.HTTP_CLIENT
        }
    }).then(response => {
        successcb(response.data)
    }).catch(error => {
        failedcb(error)
    })
}

/**
 * 踢掉线
 */
export function kickoff(uuid, topic, successcb, failedcb) {
    axios.get('/api/user/kickoff', {
        params: {
            'uuid': uuid,
            'topic': topic,
            'client': constants.HTTP_CLIENT
        }
    }).then(response => {
        successcb(response.data)
    }).catch(error => {
        failedcb(error)
    })
}

/**
 * 客服端登录成功之后，推送到公众号提示用户已经登录
 */
// export function loginSuccess(successcb, failedcb) {
//     axios.get('/api/user/login/success', {
//         params: {
//             'client': constants.HTTP_CLIENT
//         }
//     }).then(response => {
//         successcb(response.data)
//     }).catch(error => {
//         failedcb(error)
//     })
// }

/**
 * 登入更新状态
 * @param {*} successcb 成功回调
 * @param {*} failedcb 失败回调
 */
export function updateLogin (successcb, failedcb) {
    axios.post('/api/user/login', {
        client: constants.HTTP_CLIENT
    }).then(response => {
        successcb(response.data)
    }).catch(error => {
        failedcb(error)
    })
}

/**
 * 登出
 * @param {*} successcb 成功回调
 * @param {*} failedcb 失败回调
 */
export function logout (successcb, failedcb) {
    axios.post('/api/user/logout', {
        client: constants.HTTP_CLIENT
    }).then(response => {
        successcb(response.data)
    }).catch(error => {
        failedcb(error)
    })
}

/**
 * 获取客服全部联系人
 * @param {*} successcb 成功回调
 * @param {*} failedcb 失败回调
 */
export function getContacts (successcb, failedcb) {
    axios.get('/api/user/contacts', {
        params: {
        'client': constants.HTTP_CLIENT
        }
    }).then(response => {
        successcb(response.data)
    }).catch(error => {
        failedcb(error)
    })
}

/**
 * 分页获取客服账号
 * @param {*} successcb 成功回调
 * @param {*} failedcb 失败回调
 */
export function getAgents (page, size, successcb, failedcb) {
    axios.get('/api/user/get', {
        params: {
        'page': page,
        'size': size,
        'client': constants.HTTP_CLIENT
        }
    }).then(response => {
        successcb(response.data)
    }).catch(error => {
        failedcb(error)
    })
}

/**
 * 管理员获取全部成员
 * 客服组长获取同组全部组员
 * 客服账号返回自己
 *
 * @param {*} successcb 成功回调
 * @param {*} failedcb 失败回调
 */
export function getWorkGroupMembers (successcb, failedcb) {
    axios.get('/api/user/workGroupMembers', {
        params: {
        'client': constants.HTTP_CLIENT
        }
    }).then(response => {
        successcb(response.data)
    }).catch(error => {
        failedcb(error)
    })
}

/**
 * 获取当前在线&&接待状态客服账号
 * 分页
 * @param {*} successcb 成功回调
 * @param {*} failedcb 失败回调
 */
// export function getOnlineAgents (page, size, successcb, failedcb) {
//     axios.get('/api/user/online', {
//         params: {
//         'page': page,
//         'size': size,
//         'client': constants.HTTP_CLIENT
//         }
//     }).then(response => {
//         successcb(response.data)
//     }).catch(error => {
//         failedcb(error)
//     })
// }

// 加载同一个公司内-全部当前在线客服
export function getOnlineAgents(successcb, failedcb) {
    axios.get('/api/user/online/list', {
        params: {
            'client': constants.HTTP_CLIENT
        }
    }).then(response => {
        successcb(response.data)
    }).catch(error => {
        failedcb(error)
    })
}

// 客服端-根据访客渠道来源client拉取访客, client完全匹配
export function getVisitorByClient(page, size, client, successcb, failedcb) {
    axios.get('/api/user/visitor/client', {
        params: {
            'page': page,
            'size': size,
            'client': client
        }
    }).then(response => {
        successcb(response.data)
    }).catch(error => {
        failedcb(error)
    })
}

// 客服端-根据访客渠道来源client拉取访客, client通过like匹配
export function getVisitorByClientLike(page, size, client, successcb, failedcb) {
    axios.get('/api/user/visitor/client/like', {
        params: {
            'page': page,
            'size': size,
            'client': client
        }
    }).then(response => {
        successcb(response.data)
    }).catch(error => {
        failedcb(error)
    })
}

/**
 * 搜索客服账号
 * @param {*} successcb 成功回调
 * @param {*} failedcb 失败回调
 */
export function filterAgents (page, size, realName, successcb, failedcb) {
    axios.get('/api/user/filter', {
        params: {
        'page': page,
        'size': size,
        'realName': realName,
        'client': constants.HTTP_CLIENT
        }
    }).then(response => {
        successcb(response.data)
    }).catch(error => {
        failedcb(error)
    })
}

/**
 * 申请30天试用
 * @param {*} successcb 成功回调
 * @param {*} failedcb 失败回调
 */
// export function applyTry (mobile, successcb, failedcb) {
//     axios.post('/api/user/apply', {
//         mobile,
//         client: constants.HTTP_CLIENT
//     }).then(response => {
//         successcb(response.data)
//     }).catch(error => {
//         failedcb(error)
//     })
// }

// 获取场景二维码：公众号带参二维码url
export function queryUserMpQrcodeUrl(successcb, failedcb) {
    axios.get('/api/user/qr/scene/str', {
        params: {
            'client': 'web'
        }
    }).then(response => {
        successcb(response.data)
    }).catch(error => {
        failedcb(error)
    })
}

// 查询用户是否已经绑定公众号
export function queryUserMpOpenId(successcb, failedcb) {
    axios.get('/api/user/openid', {
        params: {
            'client': 'web'
        }
    }).then(response => {
        successcb(response.data)
    }).catch(error => {
        failedcb(error)
    })
}
